import * as React from "react";
import Box from "@mui/material/Box";
import clsx from "clsx";
import { GridColumns, DataGrid, GridCellParams } from "@mui/x-data-grid";

const columns: GridColumns = [
  {
    field: "name",
    cellClassName: "super-app-theme--cell"
  },
  {
    field: "score",
    type: "number",
    width: 140,
    cellClassName: (params: GridCellParams<number>) => {
      if (params.value == null) {
        return "";
      }

      // if (params.row.id == 2)
      //   return "super-app.positive";
      // else
      //   return "";

      return clsx("super-app", {
        negative: params.row.name == "Jane",
        positive: params.row.name != "Jane"
      });
    }
  }
];

const rows = [
  {
    id: 1,
    name: "Jane",
    score: 100
  },
  {
    id: 2,
    name: "Jack",
    score: -100
  },
  {
    id: 3,
    name: "Gill",
    score: 0
  }
];

export default function StylingCellsGrid() {
  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        "& .super-app-theme--cell": {
          backgroundColor: "rgba(0, 183, 60, 0.55)",
          color: "#1a3e72",
          fontWeight: "600"
        },
        "& .super-app.negative": {
          backgroundColor: "rgba(155, 255, 0, 0.49)",
          color: "#1a3e72",
          fontWeight: "600"
        },
        "& .super-app.positive": {
          backgroundColor: "#d47483",
          color: "#1a3e72",
          fontWeight: "600"
        }
      }}
    >
      <DataGrid rows={rows} columns={columns} />
    </Box>
  );
}
